import { Center, Text, Header, Space, Button } from '@northvolt/frontend-components'

export default function NotFoundRoute() {
  return (
    <Center>
      <Header text="404 - Not Found" />
      <Space />
      <Text text="This page doesn't exist in this part of the multiverse." />
      <Space type="l" />
      <Button
        type="link"
        label="Return to login page"
        onClick={() => {
          window.location.replace(window.location.origin)
        }}
      />
      <Space type="l" />
    </Center>
  )
}
